import React from "react";
// Libraries
import { PropTypes } from "prop-types";
import {
  Container,
  TriangleLeft,
  TriangleRight,
  MessageContainerLeft,
  MessageContainerRight,
  BubbleLeft,
  BubbleRight,
  BubbleContainer,
  TopBubbleContainer,
  BubbleTextContainer,
  BubbleUserTypeContainer,
  BubbleDateContainer,
} from "./MessagesListItem.css";
const { format, subMinutes } = require("date-fns");

const MessagesListItem = (props) => {
  const { text, date, isOwnMessage, senderName } = props;
  const bubble = (
    <div className={BubbleContainer}>
      <div className={TopBubbleContainer}>
        <h2 className={BubbleUserTypeContainer}>
          {senderName}
        </h2>
        <h4 className={BubbleDateContainer}>
          {format(subMinutes(new Date(date), new Date().getTimezoneOffset()), "yyyy-MM-dd HH:mm:ss")}
        </h4>
      </div>
      <h3 className={BubbleTextContainer}>{text}</h3>
    </div>
  );
  return (
    <div className={Container}>
      {isOwnMessage ? (
        <div className={MessageContainerRight}>
          <div className={TriangleRight}></div>
          <div className={BubbleRight}>{bubble}</div>
        </div>
      ) : (
        <div className={MessageContainerLeft}>
          <div className={TriangleLeft}></div>
          <div className={BubbleLeft}>{bubble}</div>
        </div>
      )}
    </div>
  );
};

MessagesListItem.propTypes = {
  id: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  isOwnMessage: PropTypes.bool.isRequired,
  senderName: PropTypes.string.isRequired,
};

export default MessagesListItem;



// WEBPACK FOOTER //
// ./src/Components/Lists/MessagesList/MessagesListItem.js